import React from 'react';
import './css/main.css';
import Product from './Components/Desastre';
function App() {
  return(
    <Product/>
  )
  
}

export default App;